// var url= 'sale4all.co.il';

import { API_CONFIG } from './api-config';

// One build works on every environment: the API is api.<the site this app is
// served from>, read in the browser at runtime.
//   sale4all.co.il, www.sale4all.co.il, admin.sale4all.co.il -> api.sale4all.co.il
//   dev.sale4all.co.il, admin.dev.sale4all.co.il             -> api.dev.sale4all.co.il
//   (a future stg./qa. environment works the same way, no code change)
// Anything else - localhost, a LAN IP, or server-side rendering where there is
// no window - falls back to ./api-config.ts (written by Jenkins per branch,
// your local value otherwise).
function apiFromPageHost(): string | null {
  if (typeof window === 'undefined' || !window.location) { return null; }
  const site = window.location.hostname.toLowerCase().replace(/^(www|admin)\./, '');
  return /(^|\.)sale4all\.co\.il$/.test(site) ? `https://api.${site}` : null;
}

const PAGE_API = apiFromPageHost();

export const SystemApp = {
  base_url: PAGE_API ? `${PAGE_API}/` : API_CONFIG.baseUrl,
  base_url_api: PAGE_API ?? API_CONFIG.apiUrl,
  web_socket: PAGE_API ? `${PAGE_API.replace(/^https:/, 'wss:')}/ws/` : API_CONFIG.wsUrl,
};
